export const SET_BADGE_DATA = 'SET_BADGE_DATA';
export const SET_WIDGET_INFO = 'SET_WIDGET_INFO';
